import { useState } from "react";

const useDragAndDropFiles = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (event: React.DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event: React.DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    setIsDragging(false);

    if (event.dataTransfer.files.length > 0) {
      setFiles(Array.from(event.dataTransfer.files));
    }
  };

  return {
    files,
    isDragging,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    setFiles,
  };
};

export default useDragAndDropFiles;
